import React from 'react';
import { di } from 'react-magnetic-di';
import { LazySuspense, lazyForPaint } from 'react-loosely-lazy';
import { Skeleton } from '@pole-journal-web/app-screen-skeleton';

const AsyncSubscriptionPlans = lazyForPaint(
    () => import(/* webpackChunkName: "async-subscription-plans" */ './index')
        .then(({ SubscriptionPlans }) => SubscriptionPlans)
);

export const SubscriptionPlans = () => {
    di(AsyncSubscriptionPlans, LazySuspense, Skeleton);

    return (
        <LazySuspense fallback={<Skeleton />}>
            <AsyncSubscriptionPlans />
        </LazySuspense>
    );
};
